export const createNormalize = (min: number, max: number) => (value: number) =>
  ((value - min) / (max - min)) * 100;

export const getDirectionFromDelta = (delta: number) =>
  delta < 0 ? "negative" : "positive";
